import React from 'react';
import ReactDOM from 'react-dom';

const SuccessModal = ({ isOpen, onClose, message, title = 'Success!', icon = '✅' }) => {
  if (!isOpen) return null;
  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content large" style={{ maxWidth: 400, textAlign: 'center', padding: 32 }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>{icon}</div>
        <div style={{ fontWeight: 700, fontSize: 24, marginBottom: 8, color: '#1976d2' }}>{title}</div>
        <div style={{ fontSize: 17, marginBottom: 24 }}>{message}</div>
        <button
          onClick={onClose}
          className="btn btn-primary"
          style={{ minWidth: 120, fontSize: 16 }}
        >
          Close
        </button>
      </div>
    </div>,
    document.body
  );
};

export default SuccessModal; 